<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/contract-period" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditContract") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>

    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha_num_space"
                v-slot="{ errors }"
                :name="$t('setup.label.ContractPeriod')"
              >
                <vs-input
                  :label="$t('setup.label.ContractPeriod')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="contractPeriod"
                  placeholder="Enter Contract Period"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mt-2"
            >
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ContractType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ContractType')"
                >
                  <v-select
                    label="durationTypeCode"
                    v-model="contractType"
                    :options="contractDetails.allowedperiods"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.durationTypeCode"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.durationTypeCode
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.ContractUnit')"
              >
                <vs-input
                  :label="$t('setup.label.ContractUnit')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="contractUnit"
                  placeholder="Enter Unit"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row center mb-4">
            <div class="vx-col w-full mb-5">
              <vs-button
                color="primary"
                type="border"
                class="mb-2 footerButton-cancel"
                @click="cancel"
                >{{ $t("setup.label.Cancel") }}</vs-button
              >
              <vs-button
                class="mr-3 mb-2 footerButton-next"
                @click="handleEditContract"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";

Validator.extend("alpha_num_space", {
  getMessage: (field) =>
    `${field} can only contain letters, numbers, and spaces.`,
  validate: (value) => /^[a-zA-Z0-9 ]+$/.test(value),
});

export default {
  data() {
    return {
      loading: false,
      contractPeriod: "",
      contractType: "",
      contractUnit: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      contractId: null,
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      contractDetails: (state) => state.contractPeriod.contractDetailsToEdit,
    }),
  },
  methods: {
    async fetchEditContract() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "contractPeriod/editContractDetails",
          this.contractId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.contractPeriod = this.contractDetails.subscriptionPeriod;
      this.contractType = this.contractDetails.subscriptionType;
      this.contractUnit = this.contractDetails.units;
      this.loading = false;
    },
    cancel() {
      this.$router.push(`/setup/contract-period`);
    },
    async handleEditContract() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let payload = {
        data: {
          subscriptionPeriod: this.contractPeriod,
          subscriptionType: this.contractType,
          units: this.contractUnit,
        },
        id: this.contractId,
      };
      try {
        await this.$store.dispatch(
          "contractPeriod/editContractPeriod",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Contract Period Edited Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/contract-period`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },
  mounted() {
    this.contractId = this.$route.params.id;
    this.fetchEditContract();
  },
};
</script>

<style scoped></style>
